import React from 'react';
import TopicPage from '../../../components/TopicPageNew';
import bg from '../../../assets/history2/19th_Century_-_Scramble_for_Africa.png';


function HistoryPageScrambleForAfrica() {
  return (
    <TopicPage
      topicKey="Scramble for Africa"
      title="History: Scramble for Africa"
      backgroundImage={bg}
      startRoute="/History-Scramble-For-Africa-Go"
      scrollLabels={[
        "Berlin Conference",
        "Colonial Motivations",
        "African Resistance",
      ]}
      backRoute="/history-19th-century"
      backLabel="← Return to topics"
      backButtonClassName="journey-button special"
      backButtonStyle={{ fontSize: '1.1rem', backgroundColor: '#553c0d' }}
    />
  );
}

export default HistoryPageScrambleForAfrica;
